export const initialState = {
	isAuthenticated: false,
	isInitialised: false,
	authenticatedUser: null,
	isImpersonating: false,
	impersonatedUser: null,
	accessToken: undefined,
	idToken: undefined,
};
